import React from 'react';
import styled from 'styled-components';

export const InstallmentBalanceContainer = styled.div`
    &>div{
        display:grid;
        margin-bottom:0.3rem;
        &>:last-child{
            margin-left: auto; 
            margin-right: 0;
            text-align:right;
        }
        .alignRight{
            margin-left: auto; 
            margin-right: 0;
            text-align:right;
        }
        .firstLbl{
            color:var(--light-gray);
            margin-bottom:0.5rem;
        }
        
        .val{
            margin-top:0.3rem;
            font-weight:500;
            font-weight:bold;
            color:var(--dark-gray);
            
            &>span{
                color: var(--light-gray);
            }
        }
        
        .charge{
            color:var(--alert-color);
        }
        .pending{
            color:var(--light-gray);
        }
        .approved{
            color:var(--main-color);
        }
        .dismissed{
            color:var(--light-gray);
        }
        .attachment{
            margin-bottom:-0.1rem;
            color:var(--main-color);
            cursor:pointer;
        }
    }
`
const NoFeesOrCharges = styled.div`
    text-align:center;
    font-weight:bold;
    font-size:1.5em;
    color:var(--lighter-gray);
    padding: 1rem 0rem;
`

export const InstallmentBalance = ({data})=> {
    return <InstallmentBalanceContainer $smallerfont={false}>
        {data && data.length > 0 ? 
        <>
        {
            data.map((installment, index ) => {
                let withLabel = true;
                if (index > 0)withLabel = false;
                const paidInFull = installment.paidAmount >= installment.totalAmount;
                return  <div  key={index} style={{gridTemplateColumns:"35% 1.3fr 0.7fr 1fr"}}>
                    <div>
                        {withLabel?<div className='firstLbl'>Title</div>:null}
                        <div className={`val ${paidInFull?"approved":""}`}>
                            {installment.title}
                        </div>
                    </div>
                    <div>
                        {withLabel?<div className='firstLbl'>Weekly Rate</div>:null}
                        <div className='val'>
                            {paidInFull?'-':`$${installment.weeklyRate}`}
                        </div>
                    </div>
                    <div>
                        {withLabel?<div className='firstLbl'>Current Balance</div>:null}
                        <div className={`val ${paidInFull?"approved":""}`}>
                            {installment.totalAmount>=installment.paidAmount?
                                `${paidInFull?'':'-'}$${installment.totalAmount-installment.paidAmount}`
                                :"+$"+(installment.paidAmount - installment.totalAmount)
                            }
                        </div>
                        
                    </div>
                    <div>
                        {withLabel?<div className='firstLbl'>Total Amount</div>:null}
                        <div className={`val ${paidInFull?"approved":""}`}>
                            {`$${installment.totalAmount}`}
                        </div>
                        
                    </div>
                </div>
            })
        }
        </>
        :
        <NoFeesOrCharges> No Installments Were Found</NoFeesOrCharges>
        }
        
    </InstallmentBalanceContainer>

}

